define('modules/form_editor/views/preview_custom_gender_item',['require','exports','module','base/itemview','i18n','../../editor/models/editorstate','ldsh!../templates/preview_custom_gender_item'],function(require, exports, module){
  "use strict";
  var ItemView = require("base/itemview"),
      i18n = require("i18n");
  /* Sure there is a better way to do this, but it means refactor */
  var EditorState = require("../../editor/models/editorstate");
  module.exports = ItemView.extend({
    template: require("ldsh!../templates/preview_custom_gender_item"),
    tagName: "option",
    initialize: function(options){
      this.inputName = options.parent.model.get("nameAttr");
      this.isRequired = options.parent.model.get("isRequired");
    },
    helpers: function(){
      //grab labelText from parent to use as name for every checkbox
      return {
        inputName: this.inputName
      };
    },
    onRender: function(){
      //we do this onrender because the 'attributes' function
      //is not called again upon model change
      var translationKey = this.model.get("translationKey");
      try {
        var defaultsModel = EditorState.getVariant().getPropertyGroup("page:defaults"),
            lang = defaultsModel.get("language");
        translationKey += ("_" + lang);
      } catch(e) {}
      var genderName = this.model.get("value") || this.model.get("text") || i18n.t(translationKey);
      this.$el.attr("value", this.model.get("valid") ? genderName : "");
      if (!this.model.get("text") && translationKey) 
        this.$el.attr("data-i18n", translationKey);
      this.$el.attr("socialBinding", this.model.get("socialBinding"));
      this.$el.i18n();
    }
  });
});

